export default "__VITE_ASSET__DSPWvPXW__"